import { useEffect, useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { http } from "@/lib/api";

export const PixStep = ({ order, onUpdate, onCancel }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const t = setInterval(async () => {
      try {
        const { data } = await http.get(`/orders/${order.id}`);
        if (data?.status && data.status !== order.status) onUpdate(data);
      } catch (e) { /* keep polling */ }
    }, 4000);
    return () => clearInterval(t);
  }, [order.id, order.status, onUpdate]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(order.qr_code ?? "");
      setCopied(true);
      toast.success("Código Pix copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      toast.error("Não foi possível copiar. Selecione o código manualmente.");
    }
  };

  const failed = ["rejected", "cancelled", "refunded"].includes(order.status);

  return (
    <div className="space-y-6" data-testid="pix-step">
      {order.qr_code_base64 && (
        <div className="mx-auto w-fit rounded-2xl bg-white p-3">
          <img data-testid="pix-qr-image" src={`data:image/png;base64,${order.qr_code_base64}`} alt="QR Code Pix" className="h-56 w-56" />
        </div>
      )}
      <div className="space-y-2">
        <p className="text-xs uppercase tracking-[0.25em] text-white/60">Pix copia e cola</p>
        <div className="flex gap-2">
          <input readOnly value={order.qr_code ?? ""} data-testid="pix-code-input"
            className="min-w-0 flex-1 truncate rounded-xl border border-white/15 bg-white/5 px-3 text-xs text-white/80" />
          <button onClick={copy} data-testid="pix-copy-button"
            className="flex items-center gap-2 rounded-xl bg-[var(--gold)] px-4 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#080312] transition-colors duration-300 hover:bg-[var(--gold-hi)]">
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
            {copied ? "Copiado" : "Copiar"}
          </button>
        </div>
      </div>
      <p className="text-sm text-white/70">Recebedor: <span className="text-[#F5F2EB]">Larissa Cristina Borsato</span></p>
      {failed ? (
        <div data-testid="pix-failed" className="rounded-xl border border-red-400/40 bg-red-500/10 p-4 text-sm text-red-200">
          O pagamento não foi concluído.{" "}
          <button onClick={onCancel} className="underline underline-offset-4" data-testid="pix-retry-btn">Gerar um novo Pix</button>
        </div>
      ) : (
        <div data-testid="pix-waiting" className="flex items-center gap-4 rounded-xl border border-[#CBA365]/30 bg-[#CBA365]/5 p-4">
          <span className="relative flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--gold)] opacity-70" />
            <span className="relative inline-flex h-3 w-3 rounded-full bg-[var(--gold)]" />
          </span>
          <p className="text-sm text-white/80">Aguardando o pagamento… a confirmação é automática, não feche esta janela.</p>
        </div>
      )}
    </div>
  );
};
